import Brand from './brand.js';
import brands from './brands-definition.json';

export const brandsById = {};

// for-in instead of Object.keys for IE11 compatibility without a polyfill
for (const key in brands) {
  if (Object.prototype.hasOwnProperty.call(brands, key)) {
    const brand = new Brand(brands[key]);
    brandsById[brand.id] = brand;
  }
}
